import React from 'react';

export const SoundBarOverlay = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="1108"
      height="357"
      viewBox="0 0 1108 357"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
    >
      <path d="M0 0H1108V357H0V0Z" fill="#171717" fillOpacity="0.4" />
    </svg>
  );
};
